import { Box, Text } from '@chakra-ui/react';
import fonts from 'src/theme/fonts';
import colors from 'src/theme/colors';

export default function BillingPausedNotice() {
  return (
    <Box mt="12px">
      <Text fontFamily={fonts.bold} mb="8px">
        Billing changes are temporarily paused
      </Text>
      <Text color={colors.podcastShade700}>
        We&apos;re upgrading our payment system, so subscription and show changes are paused for a
        short while. Please check back soon — thanks for your patience!
      </Text>
    </Box>
  );
}
